import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  TableWrapper: {
    position: 'relative'
  },
  ApplyFilterWrapper: {
    marginTop: theme.spacing(4),
    textAlign: 'right'
  },
  ActivateButton: {
    padding: theme.spacing(0)
  },
  UserCustomMenu: {
    '& a, & button': {
      padding: theme.spacing(0.75, 1),
      width: '100%',
      textAlign: 'left',
      fontSize: theme.typography.pxToRem(16),
      justifyContent: 'flex-start'
    }
  },
  button: {
    boxShadow: theme.customShadows.widget,
    textTransform: 'none',
    '&:active': {
      boxShadow: theme.customShadows.widgetWide
    }
  },
  FilterChip: {
    display: 'flex',
    '& span': {
      marginLeft: theme.spacing(1)
    }
  },
  categoryDesc: {
    display: 'table-row'
  },
  priceChipWrapper: {
    marginBottom: theme.spacing(0.5),
    '& .MuiChip-root': {
      justifyContent: 'flex-start',
      direction: 'ltr',
      [theme.breakpoints.up('sm')]: {
        width: '100%'
      }
    }
  },
  priceChip: {
    '& strong': {
      marginRight: theme.spacing(0.5),
      display: 'inline-block'
    }
  }
}))
